import * as Sentry from '@sentry/browser'

export default Sentry